export const isChromeBrowser = () => {
  // - IE11 returns undefined for window.chrome
  // - Opera 30 returns true for window.chrome and not undefined for window.opr
  // - Edge returns true for window.chrome
  const isChromium = Boolean(window.chrome);
  const vendorName = window.navigator.vendor;
  const isOpera = Boolean(window.opr !== undefined);
  const isIEedge = window.navigator.userAgent.includes('Edg');
  const isIOSChrome = Boolean(window.navigator.userAgent.match('CriOS'));
  return !isIOSChrome && isChromium && vendorName === 'Google Inc.' && !isOpera && !isIEedge;
};